export default __webpack_public_path__ + "static/media/9.2ab65665.png";